/**
 * Just Brilliant Search Panel
 * Full-screen panel with header + search + results
 */
(function () {
  'use strict';

  var searchEl = document.getElementById('jb-search');
  var overlay = document.getElementById('jb-search-overlay');
  var input = document.getElementById('jb-search-input');
  var closeBtn = document.getElementById('jb-search-close');
  var hamburgerBtn = document.getElementById('jb-search-hamburger');
  var defaultContent = document.getElementById('jb-search-default');
  var resultsContainer = document.getElementById('jb-search-results');
  var resultsCols = document.getElementById('jb-search-results-cols');
  var resultsProducts = document.getElementById('jb-search-results-products');
  var moreContainer = document.getElementById('jb-search-more');
  var moreLink = document.getElementById('jb-search-more-link');
  var loadingEl = document.getElementById('jb-search-loading');

  if (!searchEl || !input) return;

  var debounceTimer = null;
  var DEBOUNCE_MS = 300;
  var lastQuery = '';
  var requestController = null;
  var openedBy = null;

  /* ---- Open / Close ---- */
  function openSearch(opener) {
    openedBy = opener || document.activeElement;
    document.dispatchEvent(new CustomEvent('jb:search-open'));
    searchEl.classList.add('is-open');
    searchEl.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('jb-search-open');
    input.value = '';
    showDefault();
    setTimeout(function () { input.focus(); }, 150);
  }

  function closeSearch() {
    if (!searchEl.classList.contains('is-open')) return;
    searchEl.classList.remove('is-open');
    searchEl.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('jb-search-open');
    input.value = '';
    lastQuery = '';
    clearTimeout(debounceTimer);
    if (requestController) requestController.abort();
    requestController = null;
    showDefault();
    if (openedBy && typeof openedBy.focus === 'function') openedBy.focus({ preventScroll: true });
    openedBy = null;
  }

  function showDefault() {
    if (defaultContent) defaultContent.style.display = '';
    if (resultsContainer) resultsContainer.style.display = 'none';
    if (loadingEl) loadingEl.style.display = 'none';
  }

  function showResults() {
    if (defaultContent) defaultContent.style.display = 'none';
    if (resultsContainer) resultsContainer.style.display = '';
  }

  /* ---- Triggers ---- */
  // Open from header search link
  document.querySelectorAll('.jb-header-search, .jb-drawer__mobile-search').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch(e.currentTarget);
    });
  });

  // Close button (X in search bar)
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  // Overlay click
  if (overlay) overlay.addEventListener('click', closeSearch);

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchEl.classList.contains('is-open')) {
      closeSearch();
    }
  });

  // Hamburger inside search → close search and open drawer
  if (hamburgerBtn) {
    hamburgerBtn.addEventListener('click', function () {
      openedBy = null;
      closeSearch();
      // Trigger the main drawer open
      setTimeout(function () {
        var mainToggle = document.querySelector('.thb-header-style5__left .mobile-toggle-wrapper summary');
        if (mainToggle) mainToggle.click();
      }, 100);
    });
  }

  document.addEventListener('jb:menu-open', closeSearch);
  document.addEventListener('jb:panel-open', closeSearch);
  document.addEventListener('jb:contact-open', closeSearch);

  /* ---- Input handler ---- */
  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q.length === 0) {
      clearTimeout(debounceTimer);
      if (requestController) requestController.abort();
      requestController = null;
      showDefault();
      lastQuery = '';
      return;
    }
    if (q === lastQuery) return;
    lastQuery = q;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { fetchPredictive(q); }, DEBOUNCE_MS);
  });

  // Enter → full search page
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var q = input.value.trim();
      if (q.length > 0) {
        var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
        window.location.href = root.replace(/\/$/, '') + '/search?q=' + encodeURIComponent(q);
      }
    }
  });

  /* ---- Predictive Search API ---- */
  function fetchPredictive(query) {
    if (requestController) requestController.abort();
    requestController = new AbortController();
    if (loadingEl) loadingEl.style.display = '';

    var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    var url = root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,page,article&resources[limit]=6';

    fetch(url, { signal: requestController.signal, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Search request failed');
        return r.json();
      })
      .then(function (data) {
        if (loadingEl) loadingEl.style.display = 'none';
        if (input.value.trim() !== query) return;
        renderResults(data, query);
        showResults();
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        if (loadingEl) loadingEl.style.display = 'none';
      });
  }

  function renderResults(data, query) {
    var res = (data.resources || {}).results || {};
    var products = res.products || [];
    var collections = res.collections || [];
    var pages = res.pages || [];
    var articles = res.articles || [];

    var colsHTML = '';

    // Categories (collections + pages)
    var cats = [];
    collections.forEach(function (c) { cats.push({ title: c.title, url: c.url }); });
    pages.forEach(function (p) { cats.push({ title: p.title, url: p.url }); });

    if (cats.length > 0) {
      colsHTML += '<div class="jb-search__result-col">';
      colsHTML += '<h3 class="jb-search__result-col-title">CATEGORIES</h3>';
      colsHTML += '<ul class="jb-search__result-col-list">';
      cats.forEach(function (item) {
        colsHTML += '<li><a href="' + escAttr(item.url) + '">' + highlight(item.title, query) + '</a></li>';
      });
      colsHTML += '</ul></div>';
    }

    if (articles.length > 0) {
      colsHTML += '<div class="jb-search__result-col">';
      colsHTML += '<h3 class="jb-search__result-col-title">COLLECTIONS</h3>';
      colsHTML += '<ul class="jb-search__result-col-list">';
      articles.forEach(function (a) {
        colsHTML += '<li><a href="' + escAttr(a.url) + '">' + highlight(a.title, query) + '</a></li>';
      });
      colsHTML += '</ul></div>';
    }

    if (resultsCols) resultsCols.innerHTML = colsHTML;

    // Products
    var prodHTML = '';
    products.forEach(function (p) {
      var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
      prodHTML += '<a href="' + escAttr(p.url) + '" class="jb-search__product-card">';
      prodHTML += '<div class="jb-search__product-img">';
      if (img) prodHTML += '<img src="' + escAttr(img) + '" alt="' + escAttr(p.title) + '" loading="lazy" decoding="async">';
      prodHTML += '</div>';
      prodHTML += '<p class="jb-search__product-name">' + esc(p.title) + '</p>';
      prodHTML += '</a>';
    });
    if (resultsProducts) resultsProducts.innerHTML = prodHTML;

    // More results
    var hasAny = cats.length > 0 || articles.length > 0 || products.length > 0;
    if (moreContainer && moreLink) {
      moreContainer.style.display = hasAny ? '' : 'none';
      moreLink.href = '/search?q=' + encodeURIComponent(query);
    }

    if (!hasAny && resultsCols) {
      resultsCols.innerHTML = '<p style="color:#999;font-size:0.875rem;">No results found for "' + esc(query) + '"</p>';
    }
  }

  function highlight(text, term) {
    var safe = esc(text);
    var re = new RegExp('(' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
    return safe.replace(re, '<strong>$1</strong>');
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function escAttr(s) {
    return esc(String(s == null ? '' : s)).replace(/`/g, '&#96;');
  }
})();
